import { AppState } from "../common/constants";
import AppStateManager from "../common/managers/AppStateManager";
export default manager => {
  const {
    enabledFlippers = []
  } = AppStateManager.getInstance(manager.context)?.get(AppState.EnabledFlippers) || {};
  return enabledFlippers;
};